export default "__VITE_ASSET__Bdsw45Ui__"